import * as React from 'react';
import { isEmptyObject } from '@wix/editor-elements-common-utils';
import type { LinkProps } from '@wix/editor-elements-definitions';
import Link from '@wix/thunderbolt-elements/src/components/Link/viewer/Link';

type ConditionalLinkProps = {
  children: React.ReactNode;
  link?: LinkProps;
  className?: string;
};

export function ConditionalLink({
  children,
  link,
  className,
}: ConditionalLinkProps) {
  const hasLink = !isEmptyObject(link);
  if (!hasLink) {
    return <>{children}</>;
  }

  return (
    <Link {...link} className={className}>
      {children}
    </Link>
  );
}
